export const REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL = {
  REQUEST_FOR_APPROVAL_TITLE: {
    key: 'REQUEST_FOR_APPROVAL_TITLE',
    value: 'Which channel would you like to Request for Approval?',
  },
  PUBLISH_TITLE: {
    key: 'PUBLISH_TITLE',
    value: 'Which channel would you like to Publish',
  },
  CHOOSE_A_CHANNEL_TO_SEND_FOR_TESTING_TITLE: {
    key: 'CHOOSE_A_CHANNEL_TO_SEND_FOR_TESTING_TITLE',
    value: 'Choose a channel to Send for Testing',
  },
  SEND_FOR_TESTING_TITLE: {
    key: 'SEND_FOR_TESTING_TITLE',
    value: 'Which channel would you like to Send for Testing?',
  },
  CHOOSE_A_CHANNEL_TO_REQUEST_FOR_APPROVAL_TITLE: {
    key: 'CHOOSE_A_CHANNEL_TO_REQUEST_FOR_APPROVAL_TITLE',
    value: 'Choose a channel to Request for Approval',
  },
  CHOOSE_A_CHANNEL_TO_PUBLISH_TITLE: {
    key: 'CHOOSE_A_CHANNEL_TO_PUBLISH_TITLE',
    value: 'Choose a channel to Publish',
  },

  SELECT_A_CHANNEL_ERROR_MESSAGE: {
    key: 'SELECT_A_CHANNEL_ERROR_MESSAGE',
    value: 'Please select atleast one channel',
  },
  CANCEL_REQUEST_OR_PUBLISH_BUTTON: {
    key: 'CANCEL_REQUEST_OR_PUBLISH_BUTTON',
    value: 'Cancel',
  },
  PUBLISHING_CHANNELS_BUTTON: {
    key: 'PUBLISHING_CHANNELS_BUTTON',
    value: 'Publishing',
  },
  PUBLISH_CHANNELS_BUTTON: {
    key: 'PUBLISH_CHANNELS_BUTTON',
    value: 'Publish',
  },
  REQUESTING_FOR_APPROVAL_BUTTON: {
    key: 'REQUESTING_FOR_APPROVAL_BUTTON',
    value: 'Requesting for Approval',
  },
  REQUEST_FOR_APPROVAL_BUTTON: {
    key: 'REQUEST_FOR_APPROVAL_BUTTON',
    value: 'Request for Approval',
  },
  SENDING_FOR_TESTING_BUTTON: {
    key: 'SENDING_FOR_TESTING_BUTTON',
    value: 'Sending For Testing',
  },
  SEND_FOR_TESTING_BUTTON: {
    key: 'SEND_FOR_TESTING_BUTTON',
    value: 'Send For Testing',
  },
  WHATSAPP_MESSAGE_CHANNEL_NAME: {
    key: 'WHATSAPP_MESSAGE_CHANNEL',
    value: 'Whatsapp',
  },
  VOICE_MESSAGE_CHANNEL_NAME: {
    key: 'VOICE_MESSAGE_CHANNEL',
    value: 'Voice Message',
  },
  SMS_CHANNEL_NAME: {
    key: 'SMS_CHANNEL',
    value: 'SMS',
  },
  MESSAGE_CHANNEL_NAME: {
    key: 'MESSAGE_CHANNEL_NAME',
    value: 'Message',
  },
  SEND_TEST_MESSAGE_PLACEHOLDER: {
    key: 'SEND_TEST_MESSAGE_PLACEHOLDER',
    value: 'Press enter to add mobile numbers',
  },
  SENDING_TEST_MESSAGE: {
    key: 'SENDING_TEST_MESSAGE',
    value: 'Sending test message...',
  },
  SENDING_TEST_MESSAGES: {
    key: 'SENDING_TEST_MESSAGES',
    value: 'Sending test messages...',
  },
  SEND_TEST_MESSAGE: {
    key: 'SEND_TEST_MESSAGE',
    value: 'Send Test Message',
  },
  TRY_AGAIN_TO_SEND_TEST_MESSAGE: {
    key: 'TRY_AGAIN_TO_SEND_TEST_MESSAGE',
    value: 'Try Again',
  },
  CANCEL_SEND_TEST_MESSAGE_BUTTON: {
    key: 'CANCEL_SEND_TEST_MESSAGE_BUTTON',
    value: 'Cancel',
  },
  INVALID_MOBILE_NUMBER_ERROR_MESSAGE: {
    key: 'INVALID_MOBILE_NUMBER_ERROR_MESSAGE',
    value: 'Mobile Number is Invalid',
  },
  MOBILE_NUMBER_ALREADY_EXISTS_ERROR_MESSAGE: {
    key: 'MOBILE_NUMBER_ALREADY_EXISTS_ERROR_MESSAGE',
    value: 'Mobile Number already Exists',
  },
  TEST_MESSAGE_SENT_SUCCESS_MESSAGE: {
    key: 'TEST_MESSAGE_SENT_SUCCESS_MESSAGE',
    value: 'Test message sent successfully',
  },
  VOICE_MESSAGE_SENT_SUCCESS_MESSAGE: {
    key: 'VOICE_MESSAGE_SENT_SUCCESS_MESSAGE',
    value: 'Voice message sent successfully',
  },
  TEMPLATE_SENT_FOR_TESTING_SUCCESS_MESSAGE: {
    key: 'TEMPLATE_SENT_FOR_TESTING_SUCCESS_MESSAGE',
    value: 'Template sent for testing',
  },
  EMPTY_MOBILE_NUMBER_INPUT_ERROR_MESSAGE: {
    key: 'EMPTY_MOBILE_NUMBER_INPUT_ERROR_MESSAGE',
    value: 'Please add recipients',
  },
  LOADING_MESSAGE: {
    key: 'LOADING_MESSAGE',
    value: 'Loading ...',
  },
  EMPTY_ERROR_MESSAGE: {
    key: 'EMPTY_ERROR_MESSAGE',
    value: 'is EMPTY',
  },
};

export const SHORT_MESSAGE_TESTING_AND_PUBLISH_ENV = {
  REQUEST_FOR_APPROVAL_BUTTON: {
    key: 'REQUEST_FOR_APPROVAL_BUTTON',
    value: 'Request for approval',
  },
  PUBLISH_BUTTON: { key: 'PUBLISH_BUTTON', value: 'Publish' },
  NOT_YET_PUBLISHED: { key: 'NOT_YET_PUBLISHED', value: 'Not yet published' },
  NOT_AVAILABLE: { key: 'NOT_AVAILABLE', value: 'Not available' },
  TEMPLATE_SEND_FOR_APPROVAL_SUCCESS_MESSAGE: {
    key: 'TEMPLATE_SEND_FOR_APPROVAL_SUCCESS_MESSAGE',
    value: 'Template sent for approval',
  },
  TEMPLATE_PUBLISHED_SUCCESS_MESSAGE: {
    key: 'TEMPLATE_PUBLISHED_SUCCESS_MESSAGE',
    value: 'Template published',
  },
  PUBLISHED_ENV_TAB: { key: 'PUBLISHED_ENV_TAB', value: 'Published' },
  TESTING_ENV_TAB: { key: 'TESTING_ENV_TAB', value: 'Testing' },
  DRAFT_ENV_TAB: { key: 'DRAFT_ENV_TAB', value: 'Draft' },
  NOT_YET_SEND_FOR_PUBLISH: {
    key: 'NOT_YET_SEND_FOR_PUBLISH',
    value: 'Template not yet published',
  },
  NOT_YET_SEND_FOR_TESTING: {
    key: 'NOT_YET_SEND_FOR_TESTING',
    value: 'Template not yet send for testing.',
  },
};
